import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    fullScreenActionDialogHeaderButtonBase: {
        minWidth: '10.5rem',
        maxHeight: '3rem',
        padding: '0.75rem 2rem',
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0.5rem',
        lineHeight: '1.5rem',
        '&:hover': {
            transition: 'opacity 0.2s ease-out',
            opacity: 0.75,
        },
    },
    fullScreenActionDialogHeaderButtonLightVariant: {
        backgroundColor: defaultPalette.lightGrey.mediumDark,
        color: defaultPalette.typography.main,
        '&:hover': {
            backgroundColor: defaultPalette.lightGrey.mediumDark,
        },
    },
    fullScreenActionDialogHeaderButtonDarkVariant: {
        backgroundColor: defaultPalette.typography.main,
        color: defaultPalette.white.main,
        opacity: 1,
        '&:hover': {
            backgroundColor: defaultPalette.typography.main,
        },
    },
    fullScreenActionDialogHeaderButtonSkeleton: {
        width: {
            xs: '6rem',
            sm: '10rem',
        },
        height: '4rem',
    },
})
